<script setup lang="ts">
withDefaults(
  defineProps<{
    itemsLength: number
    canDelete?: boolean
    canEdit?: boolean
    canCreate?: boolean
    gridLength?: number
  }>(),
  {
    canDelete: true,
    canEdit: true,
    canCreate: true,
    gridLength: 4
  }
)

const emit = defineEmits<{
  (e: 'delete', index: number): void
}>()
</script>
<template>
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-3" :class="`xl:grid-cols-${gridLength} 2xl:grid-cols-${gridLength}`">
    <div
      v-if="canCreate"
      class="col-span-1 flex h-[27rem] flex-col justify-around overflow-hidden rounded-sm border-2 border-dashed bg-white"
    >
      <div class="flex flex-col items-center px-6 py-10">
        <slot name="addCard" />
      </div>

      <slot name="buttons" />
    </div>
    <div
      v-for="(_, index) in itemsLength"
      :key="index"
      class="col-span-1 flex h-[27rem] w-full flex-col overflow-hidden rounded-lg border bg-white"
    >
      <div class="mb-2 flex w-full bg-muted p-2" :class="canDelete || canEdit ? ' justify-between' : ' justify-center'">
        <button
          v-if="canDelete"
          type="button"
          class="w-4 cursor-pointer text-right text-foreground"
          @click="emit('delete', index)"
        >
          <BaseIcon name="HeroXMarkIconSolid" />
        </button>
        <div class="flex flex-1 justify-center">
          <slot :name="`header-${index}`" />
        </div>
        <div class="flex gap-1 text-foreground">
          <slot name="headerRight" :index-card="index" />
        </div>
      </div>
      <div class="flex h-full flex-col justify-between">
        <div class="h-full p-4 pt-0">
          <slot :name="`body-${index}`" />
        </div>
        <slot :name="`footer-${index}`" />
      </div>
    </div>
  </div>
</template>
